import * as React from 'react';
import {BasePureComponent} from './BaseComponent';
import * as Dati from '../Dati';
import {Trad, Tipo} from '../components/';


interface ICampoComuneProps extends Dati.IBaseProps {
    Valore: string;
    Disabilitato?: boolean
    CAP?: string;
    Provincia?: string;
}

export class CampoComune extends BasePureComponent<ICampoComuneProps, {}> {
    private _Comuni: Dati.CComune[];
    private _ListaComuni: Dati.TDictTipo = {};

    constructor(props: any) {
        super(props);
        this._Comuni = require('./Dati/comuni.json');
    }

    private PopolaComuni() {
        this._ListaComuni = {};
        let comuniApp: Dati.CComune[] = this._Comuni;
        if (this.props.CAP != undefined && this.props.CAP != "") {
            let cap: string = this.props.CAP;
            comuniApp = comuniApp.filter(c => c.cap.indexOf(cap) >= 0);
        }
        if (this.props.Provincia != undefined && this.props.Provincia != "") {
            let provincia: string = this.props.Provincia;
            comuniApp = comuniApp.filter(c => c.sigla == provincia);
        }
        for (let i: number = 0; i < comuniApp.length; i++) {
            this._ListaComuni[comuniApp[i].nome] = new Dati.CTipo(comuniApp[i].nome, comuniApp[i].nome);
        }
    }

    public render() {
        this.PopolaComuni();
        return <Tipo Dati={this._ListaComuni} ID_ChiaveString={this.props.Valore}
                     Campo={this.props.Name} OnAggiorna={this.props.OnChange}
                     OnBlur={this.props.OnBlur} Disabilitato={this.props.Disabilitato}
                     TradValori={false}/>;
    }
}



// WEBPACK FOOTER //
// ./src/components/CampoComune.tsx